import { render, staticRenderFns } from "./driver-multiselect-ajax.vue?vue&type=template&id=5de0b4ae&scoped=true&"
import script from "./driver-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./driver-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0b4ae",
  null
  
)

export default component.exports